module.exports = __webpack_public_path__ + "static/media/image8.11a61643.jpeg";